/**
 * Ticket ME1: Suchmaschinen- und Teilen-Angaben einer Mentoring-Seite.
 *
 * Derselbe Weg wie bei den Freebie-Landingpages aus Ticket LM11: Ersatzwerte für
 * Titel und Beschreibung, Vorschaubild über `shareImageMeta`, ohne Bild kein
 * Platzhalter. Kein zweiter Weg daneben.
 */

import { shareImageMeta, type ShareMetaEntry } from "@/lib/share-image-meta";

export type MentoringMetaSource = {
  title: string;
  shortDescription?: string;
  seoTitle?: string;
  seoDescription?: string;
  previewImageUrl?: string | null;
  /** Ticket KI1: dauerhaft gültige Teilen-Adresse, Vorrang vor dem signierten Bild. */
  shareImageUrl?: string | null;
};

export function mentoringSeoTitle(mentoring: MentoringMetaSource): string {
  const own = (mentoring.seoTitle ?? "").trim();
  return own || `${mentoring.title} | Mentoring von creategy`;
}

/**
 * Ticket ME3: Der Untertitel ist entfallen; als Ersatzwert dient die
 * Kurzbeschreibung, sonst ein Satz aus dem Titel.
 */
export function mentoringSeoDescription(mentoring: MentoringMetaSource): string {
  const own = (mentoring.seoDescription ?? "").trim();
  if (own) return own;
  const short = (mentoring.shortDescription ?? "").trim();
  if (short) return short;
  return `${mentoring.title}: persönliche Begleitung von creategy für politische Kommunikation.`;
}

export type HeadMetaEntry = { title: string } | ShareMetaEntry;

export function mentoringHeadMeta(mentoring: MentoringMetaSource): HeadMetaEntry[] {
  const title = mentoringSeoTitle(mentoring);
  const description = mentoringSeoDescription(mentoring);
  return [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: "website" },
    /* Ticket KI1: die dauerhaft gültige Adresse, nicht die ablaufende. */
    ...shareImageMeta(mentoring.shareImageUrl ?? mentoring.previewImageUrl),
  ];
}
